// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 848) return "static/chunks/848-1e0e1d8db432bf35.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "61d103fe8176a2f6" + ".js";
};